(function() {
  var LOCALE_TO_COUNTRY = { de: 'DE', en: 'US' };
  var COUNTRY_TO_LOCALE = { DE: 'de', US: 'en', GB: 'en', CA: 'en', AU: 'en' };

  function navigateToLocale(locale, country) {
    var url = new URL(window.location.href);
    var path = url.pathname || '/';

    if (locale === 'de' && path.indexOf('/de') !== 0) {
      path = '/de' + (path === '/' ? '/' : path);
    } else if (locale === 'en') {
      path = path.replace(/^\/de(?=\/|$)/, '') || '/';
    }

    url.pathname = path;
    url.searchParams.set('country', country);
    window.location.assign(url.pathname + url.search + url.hash);
  }

  function submitSyncedLocalization(form, locale, country) {
    var localeInput = form.querySelector('input[name="locale_code"]');
    var countryInput = form.querySelector('input[name="country_code"]');
    var returnToInput = form.querySelector('input[name="return_to"]');
    if (!localeInput || !countryInput) return false;

    localeInput.value = locale;
    countryInput.value = country;
    if (returnToInput) returnToInput.value = window.location.pathname + window.location.search;
    form.submit();
    return true;
  }

  function getCurrentLocale() {
    if (window.location.pathname.indexOf('/de') === 0) return 'de';
    if (window.Shopify && Shopify.locale) return Shopify.locale;
    if (document.documentElement.lang) return document.documentElement.lang.slice(0, 2).toLowerCase();
    return 'en';
  }

  function getCurrentCountry() {
    var countrySelect = document.querySelector('select[name="country_code"]');
    if (countrySelect && countrySelect.value) return countrySelect.value;

    var countryInput = document.querySelector('.localization-form input[name="country_code"]');
    if (countryInput && countryInput.value) return countryInput.value;

    return window.Shopify && Shopify.country ? Shopify.country : '';
  }

  document.addEventListener('click', function(e) {
    var directLocaleLink = e.target.closest('[data-artmere-locale-switch]');
    if (directLocaleLink) {
      e.preventDefault();
      var directLocale = directLocaleLink.getAttribute('data-artmere-locale-switch');
      var directCountry = LOCALE_TO_COUNTRY[directLocale] || getCurrentCountry() || 'US';
      navigateToLocale(directLocale, directCountry);
      return;
    }

    var link = e.target.closest('.localization-form a[data-value]');
    if (!link) return;

    var form = link.closest('form');
    if (!form) return;

    var value = link.getAttribute('data-value');
    var localeInput = form.querySelector('input[name="locale_code"]');
    var countryInput = form.querySelector('input[name="country_code"]');
    if (!localeInput || !countryInput) return;

    var isLocaleSwitch = value === value.toLowerCase();
    var isCountrySwitch = value === value.toUpperCase() && value.length === 2;

    if (isLocaleSwitch) {
      e.preventDefault();
      e.stopImmediatePropagation();
      submitSyncedLocalization(form, value, LOCALE_TO_COUNTRY[value] || getCurrentCountry());
    } else if (isCountrySwitch) {
      e.preventDefault();
      e.stopImmediatePropagation();
      submitSyncedLocalization(form, COUNTRY_TO_LOCALE[value] || getCurrentLocale(), value);
    }
  }, true);

})();
